import React, { Component, useEffect, useState } from "react";
import { auth } from "../../../utils/auth";
import { apiUrl } from "../../../utils/apiUrl";
import { postRequest, request } from "../../../utils/request";
import { toast } from "../../../utils/helpers";
import Loader from "../../general/Loader";
import RegistroDGIIForm from "./RegistroDGIIForm";
import Modal from "../../general/Modal";

const Configuraciones = ({sucursal, getSucursales}) => {
    const [errors, setErrors] = useState({});
    const [registro, setRegistro] = useState({});
    const [ecfCreados, setEcfCreados] = useState(sucursal.configuraciones?.ecf_creados);
    const [ecfRegistrada, setEcfRegistrada] = useState(sucursal.configuraciones?.ecf_registrada);
    const [loading, setLoading] = useState(false);
    const [showRegistroDGIIPopup, setShowRegistroDGIIPopup] = useState(false);
    const [showEditRegistroDGIIPopup, setShowEditRegistroDGIIPopup] = useState(false);

    const setupNumeraciones = async (event) => {
        event.preventDefault();

        setLoading(true);

        const response = await postRequest(
            apiUrl(`sucursales/${sucursal.id}/crear-numeraciones-electronicas`),
            {}
        );

        if (response.success) {
            if (response.data.nombre === 'ecf_creados') {
                toast('Numeraciones Electrónicas creadas exitosamente.');
                setEcfCreados(true);
            }
        }

        if (response.code === 422) {
            setErrors(response.data.message);
            toast(response.data.message, 'error');
        }

        setLoading(false);
    };

    const registrarEmpresa = async (event) => {
        event.preventDefault();

        setLoading(true);

        const data = new FormData(event.target);

        const response = await postRequest(
            apiUrl(`alanube/empresas`),
            data
        );

        if (response.success) {
            if (response.data.nombre === 'ecf_registrada') {
                toast('Sucursal Registrada Exitosamente.');
                setEcfCreados(true);
                setEcfRegistrada(true);
            }
            toggleRegistroModal();
        }

        if (response.code === 422) {
            setErrors(response.data.message);
            toast("Favor verificar todos los campos.", 'error');
        }

        setLoading(false);
    }

    const editarEmpresa = async (event) => {
        event.preventDefault();

        setLoading(true);

        const data = new FormData(event.target);

        const response = await postRequest(
            apiUrl(`alanube/empresas/${registro.uid}`),
            data
        );

        if (response.success) {
            toast('Sucursal Actualizada Exitosamente.');
            getRegistroDgii(sucursal.registroDgii);
            toggleEditRegistroModal();
        }

        if (response.code === 422) {
            setErrors(response.data.message);
            toast("Favor verificar todos los campos.", 'error');
        }

        setLoading(false);
    }

    const getRegistroDgii = async (uid) => {
        if (!uid) return;

        const response = await request(
            apiUrl(`alanube/empresas/${uid}`)
        );

        if (response.success) {
            setRegistro(response.data);
        }
    }

    const toggleRegistroModal = () => {
        setShowRegistroDGIIPopup(prev => !prev);
    }

    const toggleEditRegistroModal = () => {
        setShowEditRegistroDGIIPopup(prev => !prev);
    }

    useEffect(() => {
      getRegistroDgii(sucursal.registroDgii);
    }, [sucursal.configuraciones])

    return (
        <>
            <div className={`au-task__item ${ecfRegistrada ? 'au-task__item--success' : 'au-task__item--danger'}`}>
                <div className="au-task__item-inner row">
                    <div className="col-md-8">
                        <h5 className="task">
                            Registrar Empresa para Facturación Electrónica
                        </h5>
                        {ecfRegistrada ? (
                            <table className="table m-t-40">
                                <tbody>
                                    <tr>
                                        <th>Nombre Comercial:</th>
                                        <td>{registro.tradeName}</td>
                                        <th>RNC:</th>
                                        <td>{registro.identification}</td>
                                    </tr>
                                    <tr>
                                        <th>Tipo:</th>
                                        <td><span className="uppercase">{registro.type}</span></td>
                                        <th>Provincia:</th>
                                        <td>{registro.province}</td>
                                    </tr>
                                </tbody>
                            </table>
                        ) : (
                            <span className="time">No registrada</span>
                        )}
                    </div>
                    <div className="col-md-4 text-right">
                        {ecfRegistrada ? (
                            <button className="btn btn-primary" onClick={toggleEditRegistroModal}>
                                Editar
                            </button>
                        ) : (
                            <button className="btn btn-primary" onClick={toggleRegistroModal}>
                                Registrar
                            </button>
                        )}
                    </div>
                </div>
            </div>
            <div className={`au-task__item ${ecfCreados ? 'au-task__item--success' : 'au-task__item--danger'}`}>
                <div className="au-task__item-inner row">
                    <div className="col-md-8">
                        <h5 className="task">
                            Crear Numeraciones Electrónicas
                        </h5>
                        <small>
                            <ul style={{paddingLeft: "25px"}}>
                                <li>(E31) Factura de Crédito Fiscal Electrónico</li>
                                <li>(E32) Factura de Consumo Electrónica</li>
                                <li>(E33) Nota de Débito Electrónica</li>
                                <li>(E34) Nota de Crédito Electrónica</li>
                                <li>(E41) Compras Electrónicas</li>
                                <li>(E43) Gastos Menores Electrónico</li>
                                <li>(E44) Regímenes Especiales Electrónico</li>
                                <li>(E45) Gubernamental Electrónico</li>
                                <li>(E47) Pagos al Exterior Electrónico</li>
                            </ul>
                        </small>
                    </div>
                    <div className="col-md-4 text-right">
                        {!ecfCreados && (
                            <>
                                {loading ? (
                                    <Loader type="small" />
                                ) : (
                                    <button type="button" className="btn btn-primary" onClick={setupNumeraciones}>
                                        Configurar
                                    </button>
                                )}
                            </>
                        )}
                        {ecfCreados && (
                            <i className="zmdi zmdi-check" style={{
                                fontSize: '32px',
                                backgroundColor: '#00ad5f',
                                color: '#fff',
                                width: '50px',
                                textAlign: 'center',
                                lineHeight: '50px',
                                height: '50px',
                                borderRadius: '50px',
                            }}></i>
                        )}
                    </div>
                </div>
            </div>
            <Modal
                show={showRegistroDGIIPopup}
                blank={true}
                toggle={toggleRegistroModal}
                size="md"
            >
                <form method='post' onSubmit={registrarEmpresa}>
                    <div className='popup__header'>Registrar Empresa Para Facturación Electrónica</div>
                    <div className='popup__body'>
                        <RegistroDGIIForm
                            toggle={toggleRegistroModal}
                            registro={registro}
                            sucursal={sucursal}
                            getSucursales={getSucursales}
                            errors={errors}
                        />
                    </div>
                    <div className='popup__footer'>
                        <button
                            type='button'
                            onClick={toggleRegistroModal}
                            className='btn btn-plain'>
                            Cancelar
                        </button>
                        <button type='submit' className='btn btn-primary'>
                            Registrar
                        </button>
                    </div>
                </form>
            </Modal>
            <Modal
                show={showEditRegistroDGIIPopup}
                blank={true}
                toggle={toggleEditRegistroModal}
                size="md"
            >
                <form method='post' onSubmit={editarEmpresa}>
                    <input type="hidden" name="_method" value="PATCH" />
                    <div className='popup__header'>Editar Información de Registro Facturación Electrónica</div>
                    <div className='popup__body'>
                        <RegistroDGIIForm
                            toggle={toggleEditRegistroModal}
                            registro={registro}
                            sucursal={sucursal}
                            getSucursales={getSucursales}
                            errors={errors}
                        />
                    </div>
                    <div className='popup__footer'>
                        <button
                            type='button'
                            onClick={toggleEditRegistroModal}
                            className='btn btn-plain'>
                            Cancelar
                        </button>
                        <button type='submit' className='btn btn-primary'>
                            Guardar
                        </button>
                    </div>
                </form>
            </Modal>
        </>
    );
}

export default Configuraciones;
